// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modern Professional Admin Dashboard Styles
 * Premium Design System - GBN Admin Portal
 * UPDATED: Improved color theme with proper alignment
 */

:root {
  /* Primary Brand Colors - Ink Theme */
  --primary-dark: #0a1628;
  --primary-main: #101f38;
  --primary-light: #2f6f5e;
  --primary-lighter: #3d8a76;

  /* Accent & Secondary */
  --accent-gold: #c6a15b;
  --accent-gold-light: #e3c98a;
  --accent-warm: #c6a15b;

  /* Status Colors - Refined */
  --success: #2f6f5e;
  --success-light: #e3efe9;
  --danger: #b3432b;
  --danger-light: #fbeae5;
  --warning: #b8874a;
  --warning-light: #f6ecd9;
  --info: #132b4d;
  --info-light: #e7ecf3;

  /* Neutral Palette - Improved */
  --bg-primary: #ffffff;
  --bg-secondary: #f1ede2;
  --bg-tertiary: #f1ede2;
  --bg-dark: #0a1628;

  --text-primary: #0a1628;
  --text-secondary: #48546b;
  --text-tertiary: #8792a6;
  --text-light: #cbd5e1;

  /* Borders & Separators */
  --border-light: #e3ddcd;
  --border-main: #d8cfb8;
  --border-dark: #b8ac8e;

  /* Shadows - Enhanced */
  --shadow-xs:
    0 1px 2px 0 rgba(10, 22, 40, 0.03), 0 1px 1px 0 rgba(10, 22, 40, 0.06);
  --shadow-sm:
    0 1px 3px 0 rgba(10, 22, 40, 0.08), 0 1px 2px 0 rgba(10, 22, 40, 0.05);
  --shadow-md:
    0 4px 6px -1px rgba(10, 22, 40, 0.1), 0 2px 4px -1px rgba(10, 22, 40, 0.06);
  --shadow-lg:
    0 10px 15px -3px rgba(10, 22, 40, 0.1),
    0 4px 6px -2px rgba(10, 22, 40, 0.05);
  --shadow-xl:
    0 20px 25px -5px rgba(10, 22, 40, 0.1),
    0 10px 10px -5px rgba(10, 22, 40, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(10, 22, 40, 0.15);

  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* ============================================
   GLOBAL RESET & TYPOGRAPHY
   ============================================ */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  line-height: 1.6;
}

code {
  font-family:
    "Fira Code", "Source Code Pro", Menlo, Monaco, Consolas, monospace;
}

/* ============================================
   LAYOUT STRUCTURE
   ============================================ */

.admin-container {
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-secondary);
}

/* ============================================
   SIDEBAR NAVIGATION
   ============================================ */

.admin-sidebar {
  width: 280px;
  background: linear-gradient(180deg, #0a1628 0%, #101f38 100%);
  color: white;
  padding: 0;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  box-shadow: 0 10px 24px rgba(10, 22, 40, 0.1);
  z-index: 1000;
  transition:
    transform 300ms ease,
    width 300ms ease;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.admin-sidebar::-webkit-scrollbar {
  width: 8px;
}

.admin-sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.admin-sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.admin-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.admin-sidebar.mobile-hidden {
  transform: translateX(-100%);
}

.admin-sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(0, 0, 0, 0.08);
}

.admin-sidebar-logo {
  width: 44px;
  height: 44px;
  background: linear-gradient(
    135deg,
    var(--accent-gold) 0%,
    var(--accent-gold-light) 100%
  );
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 20px;
  color: var(--primary-dark);
  box-shadow: 0 3px 10px rgba(198, 161, 91, 0.25);
  flex-shrink: 0;
}

.admin-sidebar-title {
  font-size: 18px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: 4px;
  letter-spacing: -0.5px;
}

.admin-sidebar-subtitle {
  font-size: 11px;
  opacity: 0.75;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.admin-sidebar-nav {
  padding: 12px 6px;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.admin-sidebar-item {
  -webkit-user-select: none;
          user-select: none;
}

.admin-sidebar-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 14px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: all 180ms ease;
  font-weight: 500;
  font-size: 13px;
  border-radius: 6px;
  margin: 0 2px;
  border-left: 3px solid transparent;
  cursor: pointer;
  position: relative;
  border: none;
  background: transparent;
}

.admin-sidebar-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-left-color: var(--accent-gold);
  padding-left: 16px;
}

.admin-sidebar-link.active {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  border-left-color: var(--accent-gold);
  font-weight: 600;
}

.admin-sidebar-link svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: transform 200ms ease;
}

.admin-sidebar-link:hover svg {
  transform: translateX(2px);
}

.admin-sidebar-link:active svg {
  transform: scale(0.95);
}

/* ============================================
   MAIN CONTENT AREA
   ============================================ */

.admin-main {
  margin-left: 280px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: margin-left var(--transition-base);
}

.admin-main.mobile-full {
  margin-left: 0;
}

/* ============================================
   TOP BAR / HEADER
   ============================================ */

.admin-topbar {
  background: white;
  padding: 14px 32px;
  box-shadow: 0 1px 2px rgba(10, 22, 40, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e3ddcd;
  position: sticky;
  top: 0;
  z-index: 100;
}

.admin-topbar-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
}

.admin-topbar-toggle {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: none;
  color: var(--primary-main);
  transition: color var(--transition-fast);
  padding: 8px;
  border-radius: 8px;
}

.admin-topbar-toggle:hover {
  background: var(--bg-tertiary);
  color: var(--primary-dark);
}

.admin-topbar-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.5px;
  margin: 0;
}

.admin-topbar-search {
  display: flex;
  align-items: center;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-light);
  border-radius: 10px;
  padding: 10px 16px;
  gap: 10px;
  flex: 0 1 320px;
  transition: all var(--transition-fast);
}

.admin-topbar-search:focus-within {
  border-color: var(--primary-main);
  background: var(--bg-primary);
  box-shadow: 0 0 0 3px rgba(16, 31, 56, 0.05);
}

.admin-topbar-search svg {
  width: 18px;
  height: 18px;
  color: var(--text-tertiary);
}

.admin-topbar-search input {
  border: none;
  background: none;
  flex: 1 1;
  font-size: 14px;
  outline: none;
  color: var(--text-primary);
}

.admin-topbar-search input::placeholder {
  color: var(--text-tertiary);
}

.admin-topbar-right {
  display: flex;
  align-items: center;
  gap: 28px;
}

.admin-topbar-user {
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition: all var(--transition-fast);
  padding: 8px 12px;
  border-radius: 10px;
}

.admin-topbar-user:hover {
  background: var(--bg-tertiary);
}

.admin-topbar-avatar {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    var(--primary-main),
    var(--primary-light)
  );
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  box-shadow: var(--shadow-sm);
}

.admin-topbar-userinfo {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.admin-topbar-name {
  font-weight: 700;
  font-size: 13px;
  color: var(--text-primary);
}

.admin-topbar-role {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* ============================================
   LOGIN BUTTON
   ============================================ */

.admin-logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--danger);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-sm);
}

.admin-logout-btn:hover {
  background: #b3432b;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.admin-logout-btn:active {
  transform: translateY(0);
}

.admin-logout-btn svg {
  width: 16px;
  height: 16px;
}

/* ============================================
   MAIN CONTENT
   ============================================ */

.admin-content {
  flex: 1 1;
  padding: 24px 32px;
  overflow: hidden;
  background: #f1ede2;
  display: flex;
  flex-direction: column;
}

/* Page Container - Handles internal scrolling */
.admin-page-container {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

/* Scrollbar styling for page containers */
.admin-page-container::-webkit-scrollbar {
  width: 8px;
}

.admin-page-container::-webkit-scrollbar-track {
  background: transparent;
}

.admin-page-container::-webkit-scrollbar-thumb {
  background: #d8cfb8;
  border-radius: 4px;
}

.admin-page-container::-webkit-scrollbar-thumb:hover {
  background: #b8ac8e;
}

/* ============================================
   FORMS & INPUTS
   ============================================ */

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 13px;
  color: var(--text-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input,
.form-textarea,
.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border-light);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  transition: all var(--transition-fast);
  color: var(--text-primary);
  background-color: var(--bg-primary);
}

.form-input:hover,
.form-textarea:hover,
.form-select:hover {
  border-color: var(--border-main);
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus {
  outline: none;
  border-color: var(--primary-main);
  background-color: var(--bg-primary);
  box-shadow: 0 0 0 3px rgba(16, 31, 56, 0.08);
}

.form-input::placeholder {
  color: var(--text-tertiary);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

/* ============================================
   BUTTONS
   ============================================ */

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

.btn-primary {
  background: linear-gradient(
    135deg,
    var(--primary-main),
    var(--primary-light)
  );
  color: white;
  box-shadow: var(--shadow-md);
  border: 0;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.btn-primary:active {
  transform: translateY(-1px);
}

.btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-light);
}

.btn-secondary:hover {
  background: var(--border-light);
  border-color: var(--border-main);
}

.btn-danger {
  background: var(--danger);
  color: white;
  box-shadow: var(--shadow-md);
}

.btn-danger:hover {
  background: #b3432b;
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.btn-danger:active {
  transform: translateY(-1px);
}

.btn-success {
  background: var(--success);
  color: white;
  box-shadow: var(--shadow-md);
}

.btn-success:hover {
  background: #2f6f5e;
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.btn-success:active {
  transform: translateY(-1px);
}

.btn-warning {
  background: var(--warning);
  color: white;
  box-shadow: var(--shadow-md);
}

.btn-warning:hover {
  background: #b8874a;
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.btn-sm {
  padding: 8px 14px;
  font-size: 12px;
}

.btn-block {
  width: 100%;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

/* ============================================
   GRID SYSTEM
   ============================================ */

.grid {
  display: grid;
  gap: 16px;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

/* ============================================
   STAT CARDS
   ============================================ */

.stat-card {
  background: linear-gradient(135deg, #ffffff 0%, #f1ede2 100%);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(10, 22, 40, 0.06);
  border: 1px solid rgba(16, 31, 56, 0.1);
  display: flex;
  align-items: center;
  gap: 18px;
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 120px;
}

.stat-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background: linear-gradient(90deg, rgba(16, 31, 56, 0.05), transparent);
  transition: width 300ms ease;
}

.stat-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: transparent;
  transition: background 300ms ease;
}

.stat-card:hover {
  box-shadow: 0 16px 40px rgba(16, 31, 56, 0.12);
  transform: translateY(-4px);
  border-color: rgba(16, 31, 56, 0.2);
}

.stat-card:hover::before {
  width: 100%;
}

.stat-card:hover::after {
  background: linear-gradient(180deg, #101f38 0%, #132b4d 100%);
}

.stat-card-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card-label {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  color: #48546b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
}

.stat-card-value {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 30px;
  font-weight: 600;
  color: #0a1628;
  letter-spacing: -0.5px;
}

.stat-card-change {
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-card-change.positive {
  color: var(--success);
}

.stat-card-change.negative {
  color: var(--danger);
}

.stat-card-icon {
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
  transition: all 300ms ease;
}

.stat-card:hover .stat-card-icon {
  transform: scale(1.1) rotate(5deg);
}

.stat-card-icon.primary {
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  color: white;
  box-shadow: 0 8px 16px rgba(16, 31, 56, 0.2);
}

.stat-card-icon.success {
  background: linear-gradient(135deg, #2f6f5e 0%, #3d8a76 100%);
  color: white;
  box-shadow: 0 8px 16px rgba(47, 111, 94, 0.2);
}

.stat-card-icon.danger {
  background: linear-gradient(135deg, #b3432b 0%, #c9563a 100%);
  color: white;
  box-shadow: 0 8px 16px rgba(179, 67, 43, 0.2);
}

.stat-card-icon.warning {
  background: linear-gradient(135deg, #b8874a 0%, #d1a86a 100%);
  color: white;
  box-shadow: 0 8px 16px rgba(184, 135, 74, 0.2);
}

.stat-card-icon.info {
  background: linear-gradient(135deg, #132b4d 0%, #1c3a63 100%);
  color: white;
  box-shadow: 0 8px 16px rgba(19, 43, 77, 0.2);
}

/* ============================================
   CARDS
   ============================================ */

.card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 2px rgba(10, 22, 40, 0.04);
  border: 1px solid #e3ddcd;
  transition: all 200ms ease;
  min-height: 380px;
  display: flex;
  flex-direction: column;
}

.card:hover {
  box-shadow: 0 4px 12px rgba(10, 22, 40, 0.08);
}

.card-header {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e3ddcd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.card-title {
  font-family: 'Fraunces', Georgia, serif;
  font-size: 17px;
  font-weight: 600;
  color: #0a1628;
  letter-spacing: -0.2px;
}

.card-subtitle {
  font-size: 10px;
  color: #8792a6;
  margin-top: 2px;
  font-weight: 500;
}

.card-body {
  flex: 1 1;
  overflow-y: auto;
}

.card-footer {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.stat-card-icon.warning {
  background: linear-gradient(
    135deg,
    rgba(209, 168, 106, 0.1),
    rgba(184, 135, 74, 0.1)
  );
  color: var(--warning);
}

.stat-card-icon.info {
  background: linear-gradient(
    135deg,
    rgba(28, 58, 99, 0.1),
    rgba(19, 43, 77, 0.1)
  );
  color: var(--info);
}

/* ============================================
   TABLES
   ============================================ */

.table-container {
  overflow-x: auto;
  border-radius: 12px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table thead {
  background: var(--bg-tertiary);
  border-bottom: 2px solid var(--border-light);
}

.table thead th {
  padding: 16px;
  text-align: left;
  font-weight: 700;
  color: var(--text-primary);
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.table tbody tr {
  border-bottom: 1px solid var(--border-light);
  transition: background var(--transition-fast);
}

.table tbody tr:hover {
  background: var(--bg-tertiary);
}

.table tbody td {
  padding: 16px;
  color: var(--text-primary);
}

.table tbody td:first-child {
  font-weight: 600;
}

/* ============================================
   BADGES & TAGS
   ============================================ */

.table-badge,
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.badge-primary {
  background: rgba(16, 31, 56, 0.1);
  color: var(--primary-main);
}

.badge-success,
.badge-approved {
  background: var(--success-light);
  color: var(--success);
}

.badge-danger,
.badge-rejected {
  background: var(--danger-light);
  color: var(--danger);
}

.badge-warning,
.badge-pending {
  background: var(--warning-light);
  color: var(--warning);
}

.badge-info {
  background: var(--info-light);
  color: var(--info);
}

/* ============================================
   SIDEBAR NAV BADGE
   ============================================ */

.nav-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: linear-gradient(135deg, var(--danger) 0%, #8a3322 100%);
  color: white;
  box-shadow: 0 2px 6px rgba(179, 67, 43, 0.4);
  margin-left: auto;
  animation: nav-badge-pulse 2.5s ease-in-out infinite;
}

@keyframes nav-badge-pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 2px 6px rgba(179, 67, 43, 0.4);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 2px 10px rgba(179, 67, 43, 0.6);
  }
}

/* ============================================
   MODALS & DIALOGS
   ============================================ */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn var(--transition-fast);
}

.modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: var(--shadow-2xl);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp var(--transition-base);
}

.modal-header {
  padding: 28px;
  border-bottom: 1px solid var(--border-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background: var(--bg-tertiary);
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: color var(--transition-fast);
  padding: 4px;
  border-radius: 6px;
}

.modal-close:hover {
  color: var(--text-primary);
  background: white;
}

.modal-body {
  padding: 28px;
}

.modal-footer {
  padding: 20px 28px;
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: var(--bg-tertiary);
}

/* ============================================
   ALERTS & NOTIFICATIONS
   ============================================ */

.alert {
  padding: 16px 20px;
  border-radius: 12px;
  border: 1px solid;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 20px;
}

.alert-success {
  background: var(--success-light);
  border-color: var(--success);
  color: var(--success);
}

.alert-danger {
  background: var(--danger-light);
  border-color: var(--danger);
  color: var(--danger);
}

.alert-warning {
  background: var(--warning-light);
  border-color: var(--warning);
  color: var(--warning);
}

.alert-info {
  background: var(--info-light);
  border-color: var(--info);
  color: var(--info);
}

/* ============================================
   LOADING & EMPTY STATES
   ============================================ */

.loading {
  animation: spin 1s linear infinite;
}

.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-light);
  border-top-color: var(--primary-main);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.empty-state-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.empty-state-text {
  font-size: 14px;
  color: var(--text-secondary);
}

/* ============================================
   PAGINATION
   ============================================ */

.pagination {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  margin-top: 28px;
}

.pagination-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all var(--transition-fast);
  color: var(--text-primary);
}

.pagination-item:hover {
  border-color: var(--primary-main);
  background: var(--bg-tertiary);
}

.pagination-item.active {
  background: var(--primary-main);
  color: white;
  border-color: var(--primary-main);
}

.pagination-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   ACTIVITY STYLES
   ============================================ */

.activity-icon {
  font-size: 20px;
  margin-right: 8px;
}

.activity-green {
  color: var(--success);
}
.activity-red {
  color: var(--danger);
}
.activity-blue {
  color: var(--info);
}
.activity-yellow {
  color: var(--warning);
}
.activity-purple {
  color: #7c6a9c;
}
.activity-orange {
  color: #c6a15b;
}
.activity-gray {
  color: var(--text-tertiary);
}

/* ============================================
   ANIMATIONS
   ============================================ */

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

@media (max-width: 1024px) {
  .admin-sidebar {
    width: 240px;
  }

  .admin-main {
    margin-left: 240px;
  }

  .grid-cols-4 {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-card {
    flex-direction: column;
    gap: 16px;
  }

  .stat-card-icon {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .admin-sidebar {
    width: 100%;
    transform: translateX(-100%);
  }

  .admin-sidebar.mobile-hidden {
    transform: translateX(-100%);
  }

  .admin-sidebar.open {
    transform: translateX(0);
  }

  .admin-main {
    margin-left: 0;
  }

  .admin-topbar-toggle {
    display: block;
  }

  .admin-topbar-search {
    flex: 0 1 200px;
  }

  .admin-topbar-search input {
    font-size: 13px;
  }

  .admin-content {
    padding: 22px 24px;
  }

  .grid {
    gap: 16px;
  }

  .grid-cols-2,
  .grid-cols-3,
  .grid-cols-4 {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 18px;
    min-height: 110px;
  }

  .stat-card-value {
    font-size: 28px;
  }

  .stat-card-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }

  .card {
    padding: 20px;
  }

  .table {
    font-size: 12px;
  }

  .table th,
  .table td {
    padding: 12px 8px;
  }

  .modal-content {
    max-width: 90%;
    padding: 20px;
  }

  .modal-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 20px;
  }

  .modal-close {
    align-self: flex-end;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    flex-wrap: wrap;
    padding: 16px;
  }

  .btn {
    padding: 10px 16px;
    font-size: 13px;
  }

  .admin-topbar-user {
    gap: 8px;
  }

  .admin-topbar-avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .admin-topbar-name {
    display: none;
  }
}

@media (max-width: 480px) {
  .admin-sidebar {
    width: 100%;
  }

  .admin-topbar {
    padding: 12px 16px;
  }

  .admin-topbar-right {
    gap: 12px;
  }

  .admin-topbar-userinfo {
    display: none;
  }

  .admin-content {
    padding: 16px 12px;
  }

  .stat-card {
    padding: 16px;
    gap: 12px;
  }

  .stat-card-value {
    font-size: 24px;
  }

  .stat-card-label {
    font-size: 11px;
  }

  .stat-card-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }

  .card {
    padding: 16px;
  }

  .card-header {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  .card-title {
    font-size: 16px;
  }

  .table-container {
    overflow-x: auto;
  }

  .table {
    min-width: 300px;
    font-size: 11px;
  }

  .table th,
  .table td {
    padding: 8px 4px;
  }

  .modal-content {
    max-width: 100%;
    border-radius: 12px 12px 0 0;
  }

  .form-input,
  .btn {
    padding: 8px 12px;
    font-size: 12px;
  }

  .btn-block {
    width: 100%;
  }

  .stat-value {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;;EAE1B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;;EAEtB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;;EAErB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;;EAElB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;;EAErB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;;EAEtB,uBAAuB;EACvB;0EACwE;EACxE;0EACwE;EACxE;+EAC6E;EAC7E;;yCAEuC;EACvC;;2CAEyC;EACzC,sDAAsD;;EAEtD,gBAAgB;EAChB,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;;iDAEiD;;AAEjD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;wEAEsE;EACtE,mCAAmC;EACnC,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;sEACoE;AACtE;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb;;oBAEkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAO;EACP,eAAe;EACf,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;;;GAIC;EACD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;EACtC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;;;;GAIC;EACD,YAAY;EACZ,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;iDAEiD;;AAEjD;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,uEAAuE;EACvE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE;;;;GAIC;EACD,qBAAqB;AACvB;;AAEA;EACE;;;;GAIC;EACD,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mEAAmE;EACnE,YAAY;EACZ,4CAA4C;EAC5C,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE;;IAEE,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,sBAAsB;IACtB,6CAA6C;EAC/C;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/**\n * Modern Professional Admin Dashboard Styles\n * Premium Design System - GBN Admin Portal\n * UPDATED: Improved color theme with proper alignment\n */\n\n:root {\n  /* Primary Brand Colors - Ink Theme */\n  --primary-dark: #0a1628;\n  --primary-main: #101f38;\n  --primary-light: #2f6f5e;\n  --primary-lighter: #3d8a76;\n\n  /* Accent & Secondary */\n  --accent-gold: #c6a15b;\n  --accent-gold-light: #e3c98a;\n  --accent-warm: #c6a15b;\n\n  /* Status Colors - Refined */\n  --success: #2f6f5e;\n  --success-light: #e3efe9;\n  --danger: #b3432b;\n  --danger-light: #fbeae5;\n  --warning: #b8874a;\n  --warning-light: #f6ecd9;\n  --info: #132b4d;\n  --info-light: #e7ecf3;\n\n  /* Neutral Palette - Improved */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f1ede2;\n  --bg-tertiary: #f1ede2;\n  --bg-dark: #0a1628;\n\n  --text-primary: #0a1628;\n  --text-secondary: #48546b;\n  --text-tertiary: #8792a6;\n  --text-light: #cbd5e1;\n\n  /* Borders & Separators */\n  --border-light: #e3ddcd;\n  --border-main: #d8cfb8;\n  --border-dark: #b8ac8e;\n\n  /* Shadows - Enhanced */\n  --shadow-xs:\n    0 1px 2px 0 rgba(10, 22, 40, 0.03), 0 1px 1px 0 rgba(10, 22, 40, 0.06);\n  --shadow-sm:\n    0 1px 3px 0 rgba(10, 22, 40, 0.08), 0 1px 2px 0 rgba(10, 22, 40, 0.05);\n  --shadow-md:\n    0 4px 6px -1px rgba(10, 22, 40, 0.1), 0 2px 4px -1px rgba(10, 22, 40, 0.06);\n  --shadow-lg:\n    0 10px 15px -3px rgba(10, 22, 40, 0.1),\n    0 4px 6px -2px rgba(10, 22, 40, 0.05);\n  --shadow-xl:\n    0 20px 25px -5px rgba(10, 22, 40, 0.1),\n    0 10px 10px -5px rgba(10, 22, 40, 0.04);\n  --shadow-2xl: 0 25px 50px -12px rgba(10, 22, 40, 0.15);\n\n  /* Transitions */\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ============================================\n   GLOBAL RESET & TYPOGRAPHY\n   ============================================ */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\ncode {\n  font-family:\n    \"Fira Code\", \"Source Code Pro\", Menlo, Monaco, Consolas, monospace;\n}\n\n/* ============================================\n   LAYOUT STRUCTURE\n   ============================================ */\n\n.admin-container {\n  display: flex;\n  min-height: 100vh;\n  background-color: var(--bg-secondary);\n}\n\n/* ============================================\n   SIDEBAR NAVIGATION\n   ============================================ */\n\n.admin-sidebar {\n  width: 280px;\n  background: linear-gradient(180deg, #0a1628 0%, #101f38 100%);\n  color: white;\n  padding: 0;\n  position: fixed;\n  height: 100vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 24px rgba(10, 22, 40, 0.1);\n  z-index: 1000;\n  transition:\n    transform 300ms ease,\n    width 300ms ease;\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.admin-sidebar::-webkit-scrollbar {\n  width: 8px;\n}\n\n.admin-sidebar::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.admin-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n}\n\n.admin-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.admin-sidebar.mobile-hidden {\n  transform: translateX(-100%);\n}\n\n.admin-sidebar-header {\n  padding: 24px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.admin-sidebar-logo {\n  width: 44px;\n  height: 44px;\n  background: linear-gradient(\n    135deg,\n    var(--accent-gold) 0%,\n    var(--accent-gold-light) 100%\n  );\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 900;\n  font-size: 20px;\n  color: var(--primary-dark);\n  box-shadow: 0 3px 10px rgba(198, 161, 91, 0.25);\n  flex-shrink: 0;\n}\n\n.admin-sidebar-title {\n  font-size: 18px;\n  font-weight: 700;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  letter-spacing: -0.5px;\n}\n\n.admin-sidebar-subtitle {\n  font-size: 11px;\n  opacity: 0.75;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.admin-sidebar-nav {\n  padding: 12px 6px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.admin-sidebar-item {\n  user-select: none;\n}\n\n.admin-sidebar-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 11px 14px;\n  color: rgba(255, 255, 255, 0.75);\n  text-decoration: none;\n  transition: all 180ms ease;\n  font-weight: 500;\n  font-size: 13px;\n  border-radius: 6px;\n  margin: 0 2px;\n  border-left: 3px solid transparent;\n  cursor: pointer;\n  position: relative;\n  border: none;\n  background: transparent;\n}\n\n.admin-sidebar-link:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  border-left-color: var(--accent-gold);\n  padding-left: 16px;\n}\n\n.admin-sidebar-link.active {\n  background-color: rgba(255, 255, 255, 0.15);\n  color: white;\n  border-left-color: var(--accent-gold);\n  font-weight: 600;\n}\n\n.admin-sidebar-link svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  transition: transform 200ms ease;\n}\n\n.admin-sidebar-link:hover svg {\n  transform: translateX(2px);\n}\n\n.admin-sidebar-link:active svg {\n  transform: scale(0.95);\n}\n\n/* ============================================\n   MAIN CONTENT AREA\n   ============================================ */\n\n.admin-main {\n  margin-left: 280px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  transition: margin-left var(--transition-base);\n}\n\n.admin-main.mobile-full {\n  margin-left: 0;\n}\n\n/* ============================================\n   TOP BAR / HEADER\n   ============================================ */\n\n.admin-topbar {\n  background: white;\n  padding: 14px 32px;\n  box-shadow: 0 1px 2px rgba(10, 22, 40, 0.04);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e3ddcd;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.admin-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n}\n\n.admin-topbar-toggle {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  display: none;\n  color: var(--primary-main);\n  transition: color var(--transition-fast);\n  padding: 8px;\n  border-radius: 8px;\n}\n\n.admin-topbar-toggle:hover {\n  background: var(--bg-tertiary);\n  color: var(--primary-dark);\n}\n\n.admin-topbar-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n  margin: 0;\n}\n\n.admin-topbar-search {\n  display: flex;\n  align-items: center;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-light);\n  border-radius: 10px;\n  padding: 10px 16px;\n  gap: 10px;\n  flex: 0 1 320px;\n  transition: all var(--transition-fast);\n}\n\n.admin-topbar-search:focus-within {\n  border-color: var(--primary-main);\n  background: var(--bg-primary);\n  box-shadow: 0 0 0 3px rgba(16, 31, 56, 0.05);\n}\n\n.admin-topbar-search svg {\n  width: 18px;\n  height: 18px;\n  color: var(--text-tertiary);\n}\n\n.admin-topbar-search input {\n  border: none;\n  background: none;\n  flex: 1;\n  font-size: 14px;\n  outline: none;\n  color: var(--text-primary);\n}\n\n.admin-topbar-search input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.admin-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n}\n\n.admin-topbar-user {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  padding: 8px 12px;\n  border-radius: 10px;\n}\n\n.admin-topbar-user:hover {\n  background: var(--bg-tertiary);\n}\n\n.admin-topbar-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: linear-gradient(\n    135deg,\n    var(--primary-main),\n    var(--primary-light)\n  );\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-topbar-userinfo {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.admin-topbar-name {\n  font-weight: 700;\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.admin-topbar-role {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* ============================================\n   LOGIN BUTTON\n   ============================================ */\n\n.admin-logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-logout-btn:hover {\n  background: #b3432b;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.admin-logout-btn:active {\n  transform: translateY(0);\n}\n\n.admin-logout-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ============================================\n   MAIN CONTENT\n   ============================================ */\n\n.admin-content {\n  flex: 1;\n  padding: 24px 32px;\n  overflow: hidden;\n  background: #f1ede2;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Page Container - Handles internal scrolling */\n.admin-page-container {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Scrollbar styling for page containers */\n.admin-page-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.admin-page-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.admin-page-container::-webkit-scrollbar-thumb {\n  background: #d8cfb8;\n  border-radius: 4px;\n}\n\n.admin-page-container::-webkit-scrollbar-thumb:hover {\n  background: #b8ac8e;\n}\n\n/* ============================================\n   FORMS & INPUTS\n   ============================================ */\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 700;\n  font-size: 13px;\n  color: var(--text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-input,\n.form-textarea,\n.form-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--border-light);\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all var(--transition-fast);\n  color: var(--text-primary);\n  background-color: var(--bg-primary);\n}\n\n.form-input:hover,\n.form-textarea:hover,\n.form-select:hover {\n  border-color: var(--border-main);\n}\n\n.form-input:focus,\n.form-textarea:focus,\n.form-select:focus {\n  outline: none;\n  border-color: var(--primary-main);\n  background-color: var(--bg-primary);\n  box-shadow: 0 0 0 3px rgba(16, 31, 56, 0.08);\n}\n\n.form-input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 120px;\n  font-family: inherit;\n}\n\n/* ============================================\n   BUTTONS\n   ============================================ */\n\n.btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-decoration: none;\n  user-select: none;\n  white-space: nowrap;\n  letter-spacing: 0.3px;\n}\n\n.btn-primary {\n  background: linear-gradient(\n    135deg,\n    var(--primary-main),\n    var(--primary-light)\n  );\n  color: white;\n  box-shadow: var(--shadow-md);\n  border: 0;\n}\n\n.btn-primary:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-primary:active {\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-light);\n}\n\n.btn-secondary:hover {\n  background: var(--border-light);\n  border-color: var(--border-main);\n}\n\n.btn-danger {\n  background: var(--danger);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-danger:hover {\n  background: #b3432b;\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-danger:active {\n  transform: translateY(-1px);\n}\n\n.btn-success {\n  background: var(--success);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-success:hover {\n  background: #2f6f5e;\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-success:active {\n  transform: translateY(-1px);\n}\n\n.btn-warning {\n  background: var(--warning);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-warning:hover {\n  background: #b8874a;\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-sm {\n  padding: 8px 14px;\n  font-size: 12px;\n}\n\n.btn-block {\n  width: 100%;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* ============================================\n   GRID SYSTEM\n   ============================================ */\n\n.grid {\n  display: grid;\n  gap: 16px;\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* ============================================\n   STAT CARDS\n   ============================================ */\n\n.stat-card {\n  background: linear-gradient(135deg, #ffffff 0%, #f1ede2 100%);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 8px 24px rgba(10, 22, 40, 0.06);\n  border: 1px solid rgba(16, 31, 56, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  min-height: 120px;\n}\n\n.stat-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background: linear-gradient(90deg, rgba(16, 31, 56, 0.05), transparent);\n  transition: width 300ms ease;\n}\n\n.stat-card::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: transparent;\n  transition: background 300ms ease;\n}\n\n.stat-card:hover {\n  box-shadow: 0 16px 40px rgba(16, 31, 56, 0.12);\n  transform: translateY(-4px);\n  border-color: rgba(16, 31, 56, 0.2);\n}\n\n.stat-card:hover::before {\n  width: 100%;\n}\n\n.stat-card:hover::after {\n  background: linear-gradient(180deg, #101f38 0%, #132b4d 100%);\n}\n\n.stat-card-left {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.stat-card-label {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  font-weight: 600;\n  color: #48546b;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 8px;\n}\n\n.stat-card-value {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 30px;\n  font-weight: 600;\n  color: #0a1628;\n  letter-spacing: -0.5px;\n}\n\n.stat-card-change {\n  font-size: 11px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.stat-card-change.positive {\n  color: var(--success);\n}\n\n.stat-card-change.negative {\n  color: var(--danger);\n}\n\n.stat-card-icon {\n  width: 64px;\n  height: 64px;\n  min-width: 64px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  flex-shrink: 0;\n  transition: all 300ms ease;\n}\n\n.stat-card:hover .stat-card-icon {\n  transform: scale(1.1) rotate(5deg);\n}\n\n.stat-card-icon.primary {\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\n  color: white;\n  box-shadow: 0 8px 16px rgba(16, 31, 56, 0.2);\n}\n\n.stat-card-icon.success {\n  background: linear-gradient(135deg, #2f6f5e 0%, #3d8a76 100%);\n  color: white;\n  box-shadow: 0 8px 16px rgba(47, 111, 94, 0.2);\n}\n\n.stat-card-icon.danger {\n  background: linear-gradient(135deg, #b3432b 0%, #c9563a 100%);\n  color: white;\n  box-shadow: 0 8px 16px rgba(179, 67, 43, 0.2);\n}\n\n.stat-card-icon.warning {\n  background: linear-gradient(135deg, #b8874a 0%, #d1a86a 100%);\n  color: white;\n  box-shadow: 0 8px 16px rgba(184, 135, 74, 0.2);\n}\n\n.stat-card-icon.info {\n  background: linear-gradient(135deg, #132b4d 0%, #1c3a63 100%);\n  color: white;\n  box-shadow: 0 8px 16px rgba(19, 43, 77, 0.2);\n}\n\n/* ============================================\n   CARDS\n   ============================================ */\n\n.card {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 1px 2px rgba(10, 22, 40, 0.04);\n  border: 1px solid #e3ddcd;\n  transition: all 200ms ease;\n  min-height: 380px;\n  display: flex;\n  flex-direction: column;\n}\n\n.card:hover {\n  box-shadow: 0 4px 12px rgba(10, 22, 40, 0.08);\n}\n\n.card-header {\n  margin-bottom: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #e3ddcd;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.card-title {\n  font-family: 'Fraunces', Georgia, serif;\n  font-size: 17px;\n  font-weight: 600;\n  color: #0a1628;\n  letter-spacing: -0.2px;\n}\n\n.card-subtitle {\n  font-size: 10px;\n  color: #8792a6;\n  margin-top: 2px;\n  font-weight: 500;\n}\n\n.card-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.card-footer {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-light);\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.stat-card-icon.warning {\n  background: linear-gradient(\n    135deg,\n    rgba(209, 168, 106, 0.1),\n    rgba(184, 135, 74, 0.1)\n  );\n  color: var(--warning);\n}\n\n.stat-card-icon.info {\n  background: linear-gradient(\n    135deg,\n    rgba(28, 58, 99, 0.1),\n    rgba(19, 43, 77, 0.1)\n  );\n  color: var(--info);\n}\n\n/* ============================================\n   TABLES\n   ============================================ */\n\n.table-container {\n  overflow-x: auto;\n  border-radius: 12px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table thead {\n  background: var(--bg-tertiary);\n  border-bottom: 2px solid var(--border-light);\n}\n\n.table thead th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 700;\n  color: var(--text-primary);\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid var(--border-light);\n  transition: background var(--transition-fast);\n}\n\n.table tbody tr:hover {\n  background: var(--bg-tertiary);\n}\n\n.table tbody td {\n  padding: 16px;\n  color: var(--text-primary);\n}\n\n.table tbody td:first-child {\n  font-weight: 600;\n}\n\n/* ============================================\n   BADGES & TAGS\n   ============================================ */\n\n.table-badge,\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.badge-primary {\n  background: rgba(16, 31, 56, 0.1);\n  color: var(--primary-main);\n}\n\n.badge-success,\n.badge-approved {\n  background: var(--success-light);\n  color: var(--success);\n}\n\n.badge-danger,\n.badge-rejected {\n  background: var(--danger-light);\n  color: var(--danger);\n}\n\n.badge-warning,\n.badge-pending {\n  background: var(--warning-light);\n  color: var(--warning);\n}\n\n.badge-info {\n  background: var(--info-light);\n  color: var(--info);\n}\n\n/* ============================================\n   SIDEBAR NAV BADGE\n   ============================================ */\n\n.nav-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  background: linear-gradient(135deg, var(--danger) 0%, #8a3322 100%);\n  color: white;\n  box-shadow: 0 2px 6px rgba(179, 67, 43, 0.4);\n  margin-left: auto;\n  animation: nav-badge-pulse 2.5s ease-in-out infinite;\n}\n\n@keyframes nav-badge-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    box-shadow: 0 2px 6px rgba(179, 67, 43, 0.4);\n  }\n  50% {\n    transform: scale(1.08);\n    box-shadow: 0 2px 10px rgba(179, 67, 43, 0.6);\n  }\n}\n\n/* ============================================\n   MODALS & DIALOGS\n   ============================================ */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  animation: fadeIn var(--transition-fast);\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  box-shadow: var(--shadow-2xl);\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp var(--transition-base);\n}\n\n.modal-header {\n  padding: 28px;\n  border-bottom: 1px solid var(--border-light);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  background: var(--bg-tertiary);\n}\n\n.modal-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  transition: color var(--transition-fast);\n  padding: 4px;\n  border-radius: 6px;\n}\n\n.modal-close:hover {\n  color: var(--text-primary);\n  background: white;\n}\n\n.modal-body {\n  padding: 28px;\n}\n\n.modal-footer {\n  padding: 20px 28px;\n  border-top: 1px solid var(--border-light);\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  background: var(--bg-tertiary);\n}\n\n/* ============================================\n   ALERTS & NOTIFICATIONS\n   ============================================ */\n\n.alert {\n  padding: 16px 20px;\n  border-radius: 12px;\n  border: 1px solid;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.alert-success {\n  background: var(--success-light);\n  border-color: var(--success);\n  color: var(--success);\n}\n\n.alert-danger {\n  background: var(--danger-light);\n  border-color: var(--danger);\n  color: var(--danger);\n}\n\n.alert-warning {\n  background: var(--warning-light);\n  border-color: var(--warning);\n  color: var(--warning);\n}\n\n.alert-info {\n  background: var(--info-light);\n  border-color: var(--info);\n  color: var(--info);\n}\n\n/* ============================================\n   LOADING & EMPTY STATES\n   ============================================ */\n\n.loading {\n  animation: spin 1s linear infinite;\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border-light);\n  border-top-color: var(--primary-main);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--text-secondary);\n}\n\n.empty-state-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.empty-state-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.empty-state-text {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   PAGINATION\n   ============================================ */\n\n.pagination {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 28px;\n}\n\n.pagination-item {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all var(--transition-fast);\n  color: var(--text-primary);\n}\n\n.pagination-item:hover {\n  border-color: var(--primary-main);\n  background: var(--bg-tertiary);\n}\n\n.pagination-item.active {\n  background: var(--primary-main);\n  color: white;\n  border-color: var(--primary-main);\n}\n\n.pagination-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   ACTIVITY STYLES\n   ============================================ */\n\n.activity-icon {\n  font-size: 20px;\n  margin-right: 8px;\n}\n\n.activity-green {\n  color: var(--success);\n}\n.activity-red {\n  color: var(--danger);\n}\n.activity-blue {\n  color: var(--info);\n}\n.activity-yellow {\n  color: var(--warning);\n}\n.activity-purple {\n  color: #7c6a9c;\n}\n.activity-orange {\n  color: #c6a15b;\n}\n.activity-gray {\n  color: var(--text-tertiary);\n}\n\n/* ============================================\n   ANIMATIONS\n   ============================================ */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* ============================================\n   RESPONSIVE DESIGN\n   ============================================ */\n\n@media (max-width: 1024px) {\n  .admin-sidebar {\n    width: 240px;\n  }\n\n  .admin-main {\n    margin-left: 240px;\n  }\n\n  .grid-cols-4 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .stat-card {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .stat-card-icon {\n    width: 60px;\n    height: 60px;\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-sidebar {\n    width: 100%;\n    transform: translateX(-100%);\n  }\n\n  .admin-sidebar.mobile-hidden {\n    transform: translateX(-100%);\n  }\n\n  .admin-sidebar.open {\n    transform: translateX(0);\n  }\n\n  .admin-main {\n    margin-left: 0;\n  }\n\n  .admin-topbar-toggle {\n    display: block;\n  }\n\n  .admin-topbar-search {\n    flex: 0 1 200px;\n  }\n\n  .admin-topbar-search input {\n    font-size: 13px;\n  }\n\n  .admin-content {\n    padding: 22px 24px;\n  }\n\n  .grid {\n    gap: 16px;\n  }\n\n  .grid-cols-2,\n  .grid-cols-3,\n  .grid-cols-4 {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card {\n    padding: 18px;\n    min-height: 110px;\n  }\n\n  .stat-card-value {\n    font-size: 28px;\n  }\n\n  .stat-card-icon {\n    width: 60px;\n    height: 60px;\n    font-size: 24px;\n  }\n\n  .card {\n    padding: 20px;\n  }\n\n  .table {\n    font-size: 12px;\n  }\n\n  .table th,\n  .table td {\n    padding: 12px 8px;\n  }\n\n  .modal-content {\n    max-width: 90%;\n    padding: 20px;\n  }\n\n  .modal-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 20px;\n  }\n\n  .modal-close {\n    align-self: flex-end;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    flex-wrap: wrap;\n    padding: 16px;\n  }\n\n  .btn {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n\n  .admin-topbar-user {\n    gap: 8px;\n  }\n\n  .admin-topbar-avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n\n  .admin-topbar-name {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-sidebar {\n    width: 100%;\n  }\n\n  .admin-topbar {\n    padding: 12px 16px;\n  }\n\n  .admin-topbar-right {\n    gap: 12px;\n  }\n\n  .admin-topbar-userinfo {\n    display: none;\n  }\n\n  .admin-content {\n    padding: 16px 12px;\n  }\n\n  .stat-card {\n    padding: 16px;\n    gap: 12px;\n  }\n\n  .stat-card-value {\n    font-size: 24px;\n  }\n\n  .stat-card-label {\n    font-size: 11px;\n  }\n\n  .stat-card-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 20px;\n  }\n\n  .card {\n    padding: 16px;\n  }\n\n  .card-header {\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n  }\n\n  .card-title {\n    font-size: 16px;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .table {\n    min-width: 300px;\n    font-size: 11px;\n  }\n\n  .table th,\n  .table td {\n    padding: 8px 4px;\n  }\n\n  .modal-content {\n    max-width: 100%;\n    border-radius: 12px 12px 0 0;\n  }\n\n  .form-input,\n  .btn {\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n\n  .btn-block {\n    width: 100%;\n  }\n\n  .stat-value {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
